module.exports = __webpack_public_path__ + "static/media/didi.73944562.png";